import { Box, Skeleton } from '@mui/material';
import { resetForgotPasswordPageStyles } from '../reset-forgot-password/styles';
import { ResetForgotPasswordFormSkeleton } from './form/ResetForgotPasswordFormSkeleton';

export const ResetForgotPasswordPageSkeleton: React.FC = () => {
  return (
    <Box sx={{ py: 7.5 }} className="container-fluid">
      <Box sx={resetForgotPasswordPageStyles.container}>
        <Box sx={resetForgotPasswordPageStyles.card}>
          <Box>
            <Skeleton variant="circular" height="15rem" width="15rem" sx={{ mb: 4, mx: 'auto' }} />
          </Box>
          <ResetForgotPasswordFormSkeleton />
        </Box>
      </Box>
    </Box>
  );
};
